// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {
    getCreditMemoDisplayText,
    getCreditMemoFormName,
    getCreditMemoObjectId
} from '../../../../shared/services/credit-memo-services';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimSpecialAllowanceCalculation from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance-calculation';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledSmartFormLink from '../../../../shared/components/labeled-smart-form-link/labeled-smart-form-link';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {hasCreditMemoAction} from '../../../../shared/services/allowed-actions-services';

const CalculationTotals = props =>
    <section className='special-allowance-calculation-totals'>
        <section className='special-allowance-calculation-reimbursed-local'>
            {props.showAmountsInLocalCurrency &&
                <section>
                    <LabeledCurrency
                        className='special-allowance-calculation-header'
                        data={props.values.totalAmountReimbursedInLocalCurrency}
                        label='TOTAL_REIMBURSED_WITH_CURRENCY'
                        values={{
                            currency: props.values.localCurrency ? props.values.localCurrency.value : null
                        }}
                    />
                    <LabeledCurrency
                        data={props.values.totalAmountInLocalCurrency}
                        label='COMPANY_CONTRIBUTION'
                    />
                    <LabeledCurrency
                        data={props.values.taxInLocalCurrency}
                        label='TAX'
                    />
                    <LabeledCurrency
                        data={props.values.exchangeRate}
                        label='EXCHANGE_RATE'
                    />
                </section>
            }
        </section>
        <section className='special-allowance-calculation-reimbursed'>
            <LabeledCurrency
                className='special-allowance-calculation-header'
                data={props.values.totalAmountReimbursed}
                label='TOTAL_REIMBURSED_WITH_CURRENCY'
                values={{
                    currency: props.values.currency.value
                }}
            />
            <LabeledCurrency
                data={props.values.companyContribution}
                label='COMPANY_CONTRIBUTION'
            />
            <LabeledCurrency
                data={props.values.tax}
                label='TAX'
            />
            {hasCreditMemoAction(props.allowedActions) &&
                <LabeledSmartFormLink
                    displayText={getCreditMemoDisplayText(props.values.creditMemoNumber)}
                    formName={getCreditMemoFormName(props.values.creditMemoNumber)}
                    label='CREDIT_MEMO'
                    objectId={getCreditMemoObjectId(props.values.creditMemoNumber, props.claimNumber)}
                />
            }
        </section>
    </section>;

CalculationTotals.displayName = 'CalculationTotals';
CalculationTotals.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    showAmountsInLocalCurrency: PropTypes.bool.isRequired,
    values: PropTypes.instanceOf(ClaimSpecialAllowanceCalculation).isRequired
};
CalculationTotals.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default CalculationTotals;



// WEBPACK FOOTER //
// ./src/claim/spa/components/calculation-panel/totals.js